import { render, staticRenderFns } from "./GeolocationInstructions.vue?vue&type=template&id=36127d98&scoped=true"
import script from "./GeolocationInstructions.vue?vue&type=script&lang=js"
export * from "./GeolocationInstructions.vue?vue&type=script&lang=js"
import style0 from "./GeolocationInstructions.vue?vue&type=style&index=0&id=36127d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36127d98",
  null
  
)

export default component.exports